export default {
  'invitation-management': 'Invitation Management',
  'ib-group-manager': 'IB Group Manager',
  'allocation-records': 'Allocation Records',
  'add-group-allocation': 'Add Group Allocation',
  'member-id': 'member-id',
  name: 'name',
  email: 'email',
  'allocated-open-group': 'allocated-open-group',
  'update-time': 'update-time',
  'customer-id': 'customer-id',
  'apply-open-group': 'apply-open-group',
  status: 'status',
  remarks: 'remarks',
  'create-time': 'create-time',
  actions: 'actions',
  reapply: 'Reapply',
  'ib-client-groups': 'IB Client Groups',
  'open-groups': 'Open Groups',
  'please-select-ib-client-groups': 'Please select IB client groups',
  'please-select-open-groups': 'Please select open groups',
  'invite-code': 'Invite Code',
  'create-invite-code': 'Create Invite Code',
  search: 'Search',
  reset: 'Reset',
  'account-type': 'Account Type',
  'forbidden-account-type-selection': 'Forbid customers to choose account type',
  enabled: 'Enabled',
  disabled: 'Disabled',
  'register-hide-invite-code': 'Hide invite code on registration',
  'save-qr-code': 'Save QR code',
  'link-copied': 'Link copied',
  'copy-failed': 'Copy failed',
  'toggle-success': 'Toggled successfully',
  'create-success': 'Created successfully',
  'add-success': 'Added successfully',
  'add-failed': 'Add failed',
  'reapply-success': 'Reapplied successfully',
  'reapply-failed': 'Reapply failed',
  'please-select': 'Please select',
  'please-select-multiple': 'Please select (multiple)',
  'please-select-account-type': 'Please select account type',
  'please-select-invite-group': 'Please select invite group',
  'please-input-invite-code': 'Please input invite code',
  'please-select-customers': 'Please select customers',
  'search-placeholder-member': 'Search Member ID, Name, Email',
  // newly added
  submit: 'Submit',
  'invite-group': 'Invite Group',
  'pending-review': 'Pending review',
  approved: 'Approved',
  rejected: 'Rejected',
  'search-placeholder-invite': 'Invite Group, Invite Code',
  'reapply-open-group': 'Reapply for Open Group',
  'apply-group-for-customer': 'Apply {group} group for customer',
}
